Monitoring.Models.SocialContents.Apple ||= {}

String::endsWith = (s) ->
  this[this.length-s.length...] == s

class Monitoring.Models.SocialContents.Apple.AppleStoreContent

  constructor: (json) ->
    @json = json

  getJson: ->
    @json

  getGroupType: ->
    "apple_app_store"

  getType: ->
    "apple_app_store"

  getSubType: ->
    "apple_app_store_review_comment"

  getPrivacy: ->
    'private'

  getContentId: ->
    if @json.interaction
      @json.interaction.content_id
    else if @json.appStoreData.review_id
      @json.appStoreData.review_id
    else
      @json.content_id

  isListeningOnly: ->
    (@json.is_listening == true) || (@json.is_listening == 'true')

  isBrandContent: ->
    @json.appStoreData.author == 'Developer'

  getAuthorUsername: ->
    '' #temporary fix. check merge issues

  hasUser: ->
    true

  hasProfile: ->
    true

  hasRelated: ->
    false

  getAuthorId: ->
    @json.appStoreData.author

  getAuthorName: ->
    @json.appStoreData.author

  getAvatar: ->
    if @isBrandContent()
      window.image_path('appstore_ico.png')
    else
      window.image_path('appstore_user.png')

  getChannelText: ->
    if @isBrandContent()
      @message.channel_text
    else
      ''

  getCreatedAt: ->
    if @json.interaction
      @json.interaction.created_at
    else
      @json.created_at

  getMainText: ->
    @json.appStoreData.content

  getTitle: ->
    @json.appStoreData.title

  getLink: ->
    ""

  contentUrl: ->
    return "https://apps.apple.com/app/" + @appName() + "/id" + @appId()

  appName: ->
    @json.appStoreData.application_name

  appId: ->
    @json.appStoreData.application_id

  appVersion: ->
    if @json.appStoreData.app_version == "null"
      ""
    else
      " - " + @json.appStoreData.app_version

  starRating: ->
    @json.appStoreData.rating

  reviewBody: ->
    @json.appStoreData.content

  reviewTitle: ->
    if @json.appStoreData.title == "null"
      ""
    else
      @json.appStoreData.title

  userComment: ->
    @json.appStoreData.parent

  hasAttachments: ->
    @json.files && @json.files.length > 0

  getAttachments: (att_type) ->
    []

  hasShares: ->
    false

  getShares: ->
    []
